import React from 'react';
import { BloodDashboard } from './BloodDashboard';
import { BloodEntry } from './BloodEntry';
import { BloodReportView } from './BloodReportView';
import { TrialModal } from '../../modals/TrialModal';
import { LegalModal } from '../../modals/LegalModal';
import { useModal } from '../../../context/ModalContext';
import { useAuth } from '../../../context/AuthContext';

export function BloodTab() {
  const [activeView, setActiveView] = React.useState('dashboard');
  const { isSubscribed } = useAuth();

  const views = ['dashboard', 'reports', 'entry'];

  const icons = {
    dashboard: '📊',
    reports: '📜',
    entry: '✍️',
  };

  const { closeModal, isOpen } = useModal();

  const handleSubscribe = () => {
    closeModal();
    console.log('Subscribe triggered');
  };

  return (
    <div className="flex h-full flex-col p-0">
      {/* Top Navigation */}
      <div className="sticky top-0 z-40 flex h-12 w-full border-b border-outline bg-surface px-2">
        {views.map((view) => (
          <button
            key={view}
            className="flex-1 flex flex-col items-center justify-start pt-2 transition-colors"
            onClick={() => setActiveView(view)}
          >
            <span className={`text-2xl ${activeView === view ? 'text-primary' : 'text-on-surface-variant'}`}>
              {icons[view]}
            </span>
          </button>
        ))}
      </div>

      {/* Content Area */}
      <div className="flex-1 overflow-hidden">
        {activeView === 'dashboard' && <BloodDashboard onNavigate={setActiveView} />}
        {activeView === 'reports' && <BloodReportView />}
        {activeView === 'entry' && (isSubscribed ? <BloodEntry /> : (
          <div className="flex h-full flex-col items-center justify-center p-6">
            <div className="mb-4 rounded-full bg-error-container/20 p-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-error" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <h3 className="mb-2 text-lg font-semibold text-on-surface">Upgrade to Log Blood Results</h3>
            <p className="mb-6 text-center text-on-surface-variant">Subscribe to continue tracking your blood panel metrics.</p>
          </div>
        ))}
      </div>

      {/* Modals */}
      <TrialModal
        isOpen={isOpen('trial')}
        onClose={closeModal}
        onSubscribe={handleSubscribe}
      />
      <LegalModal
        isOpen={isOpen('legal')}
        onClose={closeModal}
        type="privacy"
      />
    </div>
  );
}
